import { z } from "zod";
/**
 * The one error shape every service returns (L-7). Clients branch on `code`,
 * never on the human-readable `message`.
 */
export const errorCode = z.enum([
    "VALIDATION",
    "UNAUTHENTICATED",
    "FORBIDDEN",
    "NOT_FOUND",
    "CONFLICT",
    "PAYLOAD_TOO_LARGE",
    "UNSUPPORTED_MEDIA_TYPE",
    "RATE_LIMITED",
    /** Upstream model/storage provider failed. Retryable. */
    "PROVIDER_ERROR",
    "UPSTREAM_UNAVAILABLE",
    "INTERNAL",
]);
export const errorEnvelope = z.object({
    error: z.object({
        code: errorCode,
        message: z.string(),
        details: z.record(z.unknown()).optional(),
        /** OTel trace id, so a user-reported failure maps to a trace (L-9). */
        traceId: z.string().optional(),
    }),
});
/** HTTP status for each error code. Single source, used by the error middleware. */
export const errorStatus = {
    VALIDATION: 400,
    UNAUTHENTICATED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    PAYLOAD_TOO_LARGE: 413,
    UNSUPPORTED_MEDIA_TYPE: 415,
    RATE_LIMITED: 429,
    PROVIDER_ERROR: 502,
    UPSTREAM_UNAVAILABLE: 503,
    INTERNAL: 500,
};
/**
 * Cursor pagination from the start (L-16) -- retrofitting it changes the
 * response shape and therefore every caller.
 */
export const pageQuery = z.object({
    limit: z.coerce.number().int().min(1).max(100).default(20),
    cursor: z.string().optional(),
});
export function pageOf(item) {
    return z.object({
        items: z.array(item),
        nextCursor: z.string().nullable(),
    });
}
export const uuid = z.string().uuid();
export const healthResponse = z.object({
    status: z.enum(["ok", "degraded"]),
    service: z.string(),
    uptimeSeconds: z.number(),
    checks: z.record(z.enum(["ok", "fail"])).optional(),
});
//# sourceMappingURL=common.js.map